<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block"> Show Performance</h1>
  <button class="btn btn-primary" style="margin-top:10px;margin-left:20px" (click)="refresh()">Refresh</button>
  <button class="btn btn-info" style="float:right;margin-top:10px" (click)="back()">Back</button>
  <br>
  <h5>Header</h5>
  <table class="table table-bordered table-sm">
    <thead>
      <tr>
        <th>Exercise</th>
        <th>ScenarioId</th>
        <th>Player Name</th>
        <th>Registered At</th>
        <th>IP <a href="https://www.showmyip.com/ip-geolocation-map/" target="_blank">Show my IP</a></th>
        <th>Location</th>

      </tr>
    </thead>
    <tbody>
      <tr>
        <td><b>{{player.exerciseId}}</b></td>
        <td>{{scenarioId}}</td>
        <td><b>{{player.player}}</b></td>
        <td>{{player.registeredAt}}</td>
        <td>{{player.ip}}</td>
        <td>{{ipLocation.city}}, {{ipLocation.region}} {{ipLocation['country']}}</td>
      </tr>
    </tbody>
  </table>

  <div class="row">
    <div class="col-md-6">
      <h5>Operating System</h5>
      <table class="table table-bordered table-sm">
        <tbody>
          <tr>
            <td>Platform</td>
            <td>{{player.platform?.platform}}</td>
          </tr>
          <tr>
            <td>Brand</td>
            <td>{{player.platform?.brands}}</td>
          </tr>
          <tr>
            <td>userAgent</td>
            <td>{{player.userAgent}}</td>
          </tr>
          <tr>
            <td>Mobile</td>
            <td>{{player.platform?.mobile}}</td>
          </tr>
          <tr>
            <td>Logical Processors</td>
            <td>{{player.logicalProcessors}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-6">
      <h5>Graphics Card</h5>
      <table class="table table-bordered table-sm">
        <tbody>
          <tr>
            <td>renderer</td>
            <td>{{player.gpuInfo?.renderer}}</td>
          </tr>
          <tr>
            <td>vendor</td>
            <td>{{player.gpuInfo?.vendor}}</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <h5>Loading Time</h5>
      <table class="table table-bordered table-sm">
        <tbody>
          <tr>
            <td>Time to First Render [ms]</td>
            <td>{{player.initiationTime.initiationTime | number: '1.0-0'}}</td>
          </tr>
          <tr>
            <td>Component loading [ms]</td>
            <td>{{player.loadComponents?.duration_ms | number: '1.0-0'}}</td>
          </tr>
          <tr>
            <td>Interactivity Loading [ms]</td>
            <td>{{player.interactivities?.loadingTime | number: '1.0-0'}}</td>
          </tr>

        </tbody>
      </table>
      <b>Components</b> with file size {{totalComponentFileSize | number: '1.0-0'}} KB<br>
      Filesize is only recorded when the flag doLogAssetSizes is true in the scenario.<br>
      When set to false, it will not fetch assets sizes and speed up download.<br>
      <button class="btn btn-info btn-sm" (click)="showComponentDownload = !showComponentDownload">Show / Hide Components</button>
      <br>
      <table *ngIf="showComponentDownload" class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>File Size</th>
            <th>Load Time [ms]</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let component of player.loadComponents?.formattedDetails">
            <td>{{component.Name}}</td>
            <td>{{component.FileSizeKB | number: '1.0-0'}}</td>
            <td>{{component.LoadTimeMS | number: '1.0-0'}}</td>
          </tr>

        </tbody>
      </table>
      <br>
      <b>Interactivities</b> <br>
      <button class="btn btn-info btn-sm" (click)="showInteractivities = !showInteractivities">Show / Hide Components</button>
      <br>
      <table *ngIf="showInteractivities" class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Duration [ms]</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let inter of player.interactivities?.interactivityTimes">
            <td>{{inter.name}}</td>
            <td>{{inter.time | number: '1.2-2'}}</td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="col-md-6">
      <h5>Rendering Time</h5>
      <table class="table table-bordered table-sm">
        <tbody>
          <tr>
            <td>FPS</td>
            <td>{{player.render?.fps}}</td>
          </tr>
          <tr>
            <td>Duration for 100 calls to update [ms]</td>
            <td>{{player.render?.durationFor100CallsMs | number: '1.2-2'}}</td>
          </tr>
          <tr>
            <td>Average Rendering Time [ms]</td>
            <td>{{player.rendering?.averageRenderTime | number: '1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
      Total Time [MS] per second: {{totalCycleLoadTime | number: '1.2-2'}}
      <br>
      ((Duration for 100 Calls ) / 100 + (Average Rendering Time))*FPS
    </div>
  </div>
  <hr>
  <button class="btn btn-info" (click)="showRawData = !showRawData">Show / Hide Raw Data</button>
  <div *ngIf="showRawData">
    <pre>{{player | json}}</pre>
  </div>
</div>